export default __webpack_public_path__ + "static/media/cwa-vector-white.b16cab1a.webp";